import { render, staticRenderFns } from "./ActiveLabel.vue?vue&type=template&id=5df66b4c&scoped=true&"
import script from "./ActiveLabel.vue?vue&type=script&lang=js&"
export * from "./ActiveLabel.vue?vue&type=script&lang=js&"
import style0 from "./ActiveLabel.vue?vue&type=style&index=0&id=5df66b4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df66b4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5df66b4c')) {
      api.createRecord('5df66b4c', component.options)
    } else {
      api.reload('5df66b4c', component.options)
    }
    module.hot.accept("./ActiveLabel.vue?vue&type=template&id=5df66b4c&scoped=true&", function () {
      api.rerender('5df66b4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ActiveLabel.vue"
export default component.exports